import { useMemo } from 'react';

import { keyBy, mapValues } from 'lodash';

import type { AdvancementInfo } from '@modules/roster-v2/models/rosterMember';

// TODO: mock data
interface AdvancementEntry {
  personGuid: string;
  /** e.g. get from /youths endpoint */
  lastRankApproved?: string;
}

const EMPTY_ENTRIES: AdvancementEntry[] = [];
// TODO: replace with real RTK Query hook once the advancement endpoint is wired up
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function useGetAdvancementQuery(_orgGuid: string): AdvancementEntry[] {
  return EMPTY_ENTRIES;
}

/**
 * Fetches advancement data for an org and returns it as a `personGuid` keyed
 * map ready to pass to `mergeEnrichment(members, 'advancement', byGuid)`.
 */
export function useAdvancementEnrichment(
  orgGuid: string,
): Record<string, AdvancementInfo> {
  const entries = useGetAdvancementQuery(orgGuid);

  return useMemo(
    () =>
      mapValues(
        keyBy(entries, 'personGuid'),
        (entry): AdvancementInfo => ({
          currentHighestRank: entry.lastRankApproved,
        }),
      ),
    [entries],
  );
}
